module.exports = __webpack_public_path__ + "static/img/banner-5.9e63c134.png";